import React from 'react';
import { useSelector } from 'react-redux';

import { List, ListItem, Popover, Box, Button, Chip } from '@material-ui/core';
import actions from '../config/actions';
import CustomizedAvatar from '../../../Common/CustomizedAvatar';
import useStyles from '../styles/sideMenu.styles';
import UserProfile from './userProfile';
import { useDispatch } from 'react-redux';
import Setting from '../../../../components/Settings';
import { logout } from '../../../../actions/authentication';
import { toggleUserSettingPopUp, UserSettingActiveTab } from '../../../../actions/userSetting';
import { Link } from 'react-router-dom';
import isActive from '../../../../helpers/routeHelper';
import classNames from 'classnames';


const Actions = ({ user, isMenuOpen }) => {
  const [anchorPopover, setAnchorPopover] = React.useState(null);
  // const [openSettingModal, setOpenSettingModal] = React.useState(false);
  const userSettingPopUp = useSelector(state => state.userSetting.userSettingPopUp);

  const styles = useStyles();
  const dispatch = useDispatch();
  const { avatar, firstName = '' } = user;

  const handlePopover = (event) => {
    event.stopPropagation();
    setAnchorPopover(event.currentTarget);
  }
  const handlePopoverClose = () => {
    setAnchorPopover(null);
  }

  const onClickLogout = () => {
    dispatch(logout());
  }
  const toggleSettingPopUp = () => {
    dispatch(toggleUserSettingPopUp());
    dispatch(UserSettingActiveTab(0));
  }

  const open = Boolean(anchorPopover);

  return (
    <List>
      {actions.map((action) => {
        const { label, name, onClick, renderIcon, link, isDisabled, comingSoon = false } = action;
        const linkClasses = classNames({
          [styles.activeMenuItem]: isActive(link),
          [styles.actionItemClosed]: !isMenuOpen,
        })

        if (isDisabled) {
          return (
            <ListItem className={styles.actionItems}>
              <div className={styles.actionItemsDisabled}>
                {renderIcon(isDisabled)}
                {isMenuOpen && <span>{label}</span>}
                {comingSoon &&
                  <Chip size="small" label="Coming Soon" />}
              </div>
            </ListItem>
          )
        }

        return (
          <ListItem key={name} className={styles.actionItems}>
            {link && (
              <Link to={link} className={linkClasses}>
                {renderIcon()}
                {isMenuOpen && <span>{label}</span>}
              </Link>
            )}
            {!link && (
              <button onClick={onClick} type="button">
                {renderIcon()}
                {isMenuOpen && <span>{label}</span>}
              </button>
            )}
          </ListItem>
        );
      })}
      <ListItem className={styles.actionItems} >
        <Box className={styles.userAction}>
          <CustomizedAvatar
            onClick={handlePopover}
            avatar={avatar}
            className={styles.avatar}
            initials={firstName.substring(0, 1)}
          >
            {isMenuOpen && <span >{firstName}</span>}
          </CustomizedAvatar>
        </Box>
      </ListItem>
      <Popover
        id="setting"
        open={open}
        anchorEl={anchorPopover}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <UserProfile
          user={user}
          handleClose={handlePopoverClose}
          onClickSetting={() => toggleSettingPopUp()}
          onClickLogout={onClickLogout} />
      </Popover>
      <Setting
        open={userSettingPopUp}
        handleClose={() => toggleSettingPopUp()}
      />
    </List>
  );
};


export default Actions;

